import type { DraftStep, WorkflowDraft } from './types';

/**
 * Which level an AI step's effective execution image actually comes from.
 *
 * Precedence is step > workflow > deployment default (data-model.md,
 * inherited unchanged from the backend's own FR-003/FR-004/FR-005). Pure and
 * synchronous: no I/O, so a caller can derive it on every render with no new
 * query (spec FR-006).
 */
export type EffectiveImageSource =
  | { source: 'step'; imageRef: string }
  | { source: 'workflow'; imageRef: string }
  | { source: 'default' };

export function resolveEffectiveImageSource(
  draft: Pick<WorkflowDraft, 'image'>,
  step: Pick<DraftStep, 'image'>,
): EffectiveImageSource {
  if (step.image != null) return { source: 'step', imageRef: step.image };
  if (draft.image != null) {
    return { source: 'workflow', imageRef: draft.image };
  }
  return { source: 'default' };
}
